import script from "./SvgBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgBlock.vue?vue&type=script&setup=true&lang=js"

import "./SvgBlock.vue?vue&type=style&index=0&id=54c8039f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c8039f"]])

export default __exports__